import { useEffect, useState } from "react";
import { GET_ALL_SUBURBS } from "../api/constants";

const useDetailedSuburbs = ({ cityId = null, enabled = true } = {}) => {
  const [suburbs, setSuburbs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    const fetchDetailedSuburbs = async () => {
      try {
        setLoading(true);
        setError(null);

         const response = await fetch(GET_ALL_SUBURBS);
        const json = await response.json();

        // ✅ exact API shape handling
        if (json?.success && Array.isArray(json.data)) {
          setSuburbs(json.data);
        } else {
          setSuburbs([]);
        }
      } catch (err) {
        console.error("Error fetching detailed suburbs:", err);
        setError(err);
        setSuburbs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDetailedSuburbs();
  }, [cityId, enabled]);

  return { suburbs, loading, error };
};

export default useDetailedSuburbs;
